// extracted by mini-css-extract-plugin
export default {"topPadding":"TopLableBg_topPadding__-51Xu","topbar":"TopLableBg_topbar__DYAaJ","img":"TopLableBg_img__iEiCL","title":"TopLableBg_title__RFIgn","line":"TopLableBg_line__hfMJJ"};